import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthProvider.js';

export function Dashboard() {
  const { t } = useTranslation('common');
  const { user, activeOrgId, activeRole, memberships } = useAuth();
  const activeOrg = memberships.find((m) => m.organization_id === activeOrgId);
  return (
    <div>
      <h1 className="text-2xl font-bold">{t('appName')}</h1>
      <p className="mt-2 text-sm text-slate-600">
        {user?.name ?? user?.email} — {activeRole} en {activeOrg?.organization_name ?? activeOrgId}
      </p>
      <p className="mt-1 text-xs text-slate-500">Wave 1 traerá los módulos contables aquí.</p>
    </div>
  );
}
